import React, { useEffect, useState } from 'react';
import SquaredImage from '../../SquaredImage/SquaredImage';

import styles from './cardInfo.module.scss';
import { User, UsersILike } from '../../../global';
import { useNavigate } from 'react-router-dom';
import profileImg from '../../../assets/Profile.png';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { userUrlForUser } from '../../../helpers/navigationUtils';
export interface ICardInfo {
  image?: string;
  circle?: boolean;
  altText?: string;
  name?: string;
  userId?: number;
  children?: React.ReactNode;
}

interface Props {
  user?: User | UsersILike;
  path?: string;
  circle?: boolean;
  children?: React.ReactNode;
}

const CardInfo: React.FC<Props> = ({ user, path, children, circle = true }) => {
  const redirect = useNavigate();
  const [image, setImage] = useState<string>(user?.logo ?? '');

  useEffect(() => {
    console.log('CARDINFO');
    console.log(user);
    if (user) {
      setImage(user.logo);
    }
  }, [user]);

  useEffect(() => {
    if (path) {
      setImage(path);
    }
  }, [path]);

  const goToDetail = async () => {
    if (user) redirect(userUrlForUser(user));
  };

  return (
    <div className={`${styles.cardInfoWrapper}  d-flex flex-column bg-light position-relative`}>
      <div className={`${image ? styles.cardInfoImage : styles.cardImagePlaceholder} bg-light px-5 pt-4`} onClick={() => goToDetail()} style={{ cursor: 'pointer' }}>
        {image ? (
          <SquaredImage image={image} altText={user?.username} circle={circle} />
        ) : (
          <div className={`${styles.squaredImageWrapper}`}>
            <div className={`${styles.imageInner}`}>
              <img src={profileImg} alt="profile" />
            </div>
          </div>
        )}
      </div>
      <div className={`${styles.cardInfoContent} bg-light`}>{children}</div>
    </div>
  );
};

export default CardInfo;
